
(() => {
  if (window.__amacStickerGalleryLoaded) return;
  window.__amacStickerGalleryLoaded = true;

  function initialize(container) {
    const galleries = [];
    if (container.matches && container.matches('[data-amac-sticker-root]')) galleries.push(container);
    if (container.querySelectorAll) galleries.push(...container.querySelectorAll('[data-amac-sticker-root]'));

    for (const root of galleries) {
      if (root.dataset.amacReady === 'true') continue;
      root.dataset.amacReady = 'true';

      const image = root.querySelector('[data-amac-main-image]');
      const link = root.querySelector('[data-amac-main-link]');
      const thumbs = [...root.querySelectorAll('[data-amac-thumb]')];

      for (const button of thumbs) {
        button.addEventListener('click', () => {
          if (!image || !link) return;
          image.src = button.dataset.full || image.src;
          image.removeAttribute('srcset');
          image.alt = button.dataset.alt || image.alt;
          link.href = button.dataset.zoom || link.href;
          for (const candidate of thumbs) {
            const selected = candidate === button;
            candidate.classList.toggle('is-selected', selected);
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          }
        });
      }


      const dialog = root.querySelector('[data-amac-lightbox]');
      if (dialog && link && image) {
        const enlarged = dialog.querySelector('[data-amac-lightbox-image]');
        const viewport = dialog.querySelector('[data-amac-viewport]');
        const canvas = dialog.querySelector('[data-amac-canvas]');
        const zoomIn = dialog.querySelector('[data-amac-zoom-in]');
        const zoomOut = dialog.querySelector('[data-amac-zoom-out]');
        const level = dialog.querySelector('[data-amac-zoom-level]');
        let scale = 1;
        let previousOverflow = '';
        function resize() {
          level.value = Math.round(scale * 100) + '%';
          zoomOut.disabled = scale <= 1;
          zoomIn.disabled = scale >= 4;
          const width = enlarged.naturalWidth || image.naturalWidth || Number(image.getAttribute('width'));
          const height = enlarged.naturalHeight || image.naturalHeight || Number(image.getAttribute('height'));
          if (!width || !height) return;
          const fit = Math.min((viewport.clientWidth - 32) / width, (viewport.clientHeight - 32) / height, 1);
          const renderedWidth = Math.round(width * fit * scale);
          const renderedHeight = Math.round(height * fit * scale);
          enlarged.style.width = renderedWidth + 'px';
          enlarged.style.height = renderedHeight + 'px';
          canvas.style.width = Math.max(viewport.clientWidth, renderedWidth + 32) + 'px';
          canvas.style.height = Math.max(viewport.clientHeight, renderedHeight + 32) + 'px';
          level.value = Math.round(scale * 100) + '%';
          zoomOut.disabled = scale <= 1;
          zoomIn.disabled = scale >= 4;
        }
        function changeZoom(next) {
          const centerX = (viewport.scrollLeft + viewport.clientWidth / 2) / canvas.offsetWidth;
          const centerY = (viewport.scrollTop + viewport.clientHeight / 2) / canvas.offsetHeight;
          scale = Math.min(4, Math.max(1, next));
          resize();
          viewport.scrollLeft = centerX * canvas.offsetWidth - viewport.clientWidth / 2;
          viewport.scrollTop = centerY * canvas.offsetHeight - viewport.clientHeight / 2;
        }
        link.addEventListener('click', event => {
          event.preventDefault();
          scale = 1;
          enlarged.alt = image.alt;
          enlarged.src = link.href;
          previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          resize();
          viewport.scrollTo(0, 0);
        });
        enlarged.addEventListener('load', resize);
        zoomIn.addEventListener('click', () => changeZoom(scale + 0.5));
        zoomOut.addEventListener('click', () => changeZoom(scale - 0.5));
        enlarged.addEventListener('click', () => changeZoom(scale === 1 ? 2 : 1));
        dialog.querySelector('[data-amac-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = previousOverflow;
          link.focus({ preventScroll: true });
        });
        window.addEventListener('resize', () => { if (dialog.open) resize(); });
      }

      const qty = root.querySelector('input[name="quantity"]');
      const minus = root.querySelector('[data-amac-qty-decrease]');
      const plus = root.querySelector('[data-amac-qty-increase]');

      function limitQuantity(nextValue) {
        if (!qty) return;
        const minimum = Math.max(1, parseInt(qty.min || '1', 10));
        const step = Math.max(1, parseInt(qty.step || '1', 10));
        const maximum = qty.max !== '' ? Number(qty.max) : Infinity;
        let next = Number(nextValue);
        if (!Number.isFinite(next)) next = minimum;
        next = Math.max(minimum, Math.min(maximum, next));
        next = minimum + Math.max(0, Math.floor((next - minimum) / step)) * step;
        qty.value = String(next);
        if (minus) minus.disabled = next <= minimum;
        if (plus) plus.disabled = next + step > maximum;
      }
      if (qty) {
        limitQuantity(qty.value);
        qty.addEventListener('change', () => limitQuantity(qty.value));
      }
      if (minus) minus.addEventListener('click', () => limitQuantity(Number(qty.value) - Number(qty.step || 1)));
      if (plus) plus.addEventListener('click', () => limitQuantity(Number(qty.value) + Number(qty.step || 1)));

      const selector = root.querySelector('[data-amac-variant]');
      const optionPickers = [...root.querySelectorAll('[data-amac-option-picker]')];
      const hiddenId = root.querySelector('input.product-variant-id[name="id"]');
      const price = root.querySelector('[data-amac-price]');
      const submit = root.querySelector('.product-form__submit');
      const addLabel = root.querySelector('[data-amac-add-label]');
      if (selector) {
        selector.addEventListener('change', () => {
          const selected = selector.selectedOptions[0];
          if (!selected || !hiddenId) return;
          hiddenId.value = selected.value;
          const available = selected.dataset.available === 'true';
          if (price && selected.dataset.price) price.textContent = selected.dataset.price;
          const compare = root.querySelector('[data-amac-compare]');
          if (compare) { compare.hidden = selected.dataset.onSale !== 'true'; compare.textContent = selected.dataset.compare || ''; }
          if (image && link && selected.dataset.image) {
            image.src = selected.dataset.image;
            image.removeAttribute('srcset');
            image.alt = selected.dataset.alt || image.alt;
            link.href = selected.dataset.zoom;
            const matchingThumb = thumbs.find(button => button.dataset.zoom === selected.dataset.zoom);
            for (const button of thumbs) {
              const active = button === matchingThumb;
              button.classList.toggle('is-selected', active);
              button.setAttribute('aria-pressed', active ? 'true' : 'false');
            }
          }
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
          if (submit) {
            submit.disabled = !available;
            submit.setAttribute('aria-disabled', available ? 'false' : 'true');
          }
          if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
          if (qty) {
            qty.min = selected.dataset.min || '1';
            qty.step = selected.dataset.step || '1';
            qty.max = selected.dataset.max || '';
            limitQuantity(qty.value);
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url.toString());
        });
      }
      if (selector && optionPickers.length > 1) {
        // Maintain an explicit Edition x Size variant; preserve the visitor's other choice.
        function syncVariantFromOptions() {
          const chosen = optionPickers.map(picker => picker.value);
          const matching = [...selector.options].find(option =>
            chosen.every((value, index) => option.dataset['option' + (index + 1)] === value)
          );
          if (!matching) return;
          selector.value = matching.value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
        for (const picker of optionPickers) picker.addEventListener('change', syncVariantFromOptions);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);

  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();